@if (isCurrentRole(ROLE_DOCTOR)) {

  <div class="tab-list-header">
    <div class="content-wrapper">
      <a
        class="tab-list-item active"
        [class.active]="isActiveTab(UPCOMING)"
        (click)="changeActiveTab(UPCOMING)"
        >
        <span>{{ "WAITINGROOM.TAB-UPCOMING" | translate }}</span>
      </a>
      <div
        class="tab-list-item"
        [class.active]="isActiveTab(HISTORY)"
        (click)="changeActiveTab(HISTORY)"
        >
        <span>{{ "WAITINGROOM.TAB-HISTORY" | translate }}</span>
      </div>
    </div>
  </div>
  <div class="dashboard-container">
    <div class="container-fluid">
      @if (isInit$ | async) {
        <div class="preloader-container">
          <h3 class="preloader-container-message">
            {{ "WAITINGROOM.APPOINTMENTS-LOADING" | translate }}
          </h3>
        </div>
      }
    </div>
  </div>
  @if (isActiveTab(UPCOMING)) {
    @if (
      hasNoAppointments(
      (upComingAppointments$ | async)?.length,
      isInit$ | async
      )
      ) {
      <div
        class="empty-appointments content-wrapper"
        >
        <h3 class="no-appointment-message">
          {{ "WAITINGROOM.EMPTY-APPOINTMENTS-UPCOMING" | translate }}
        </h3>
      </div>
    }
    @if ((upComingAppointments$ | async)?.length > 0) {
      <div
        class="appointment-info-wrapper"
        >
        @for (appointment of upComingAppointments$ | async; track appointment) {
          <app-appointment-info
            [appointment]="appointment"
            [appointmentInfoType]="WAITINGROOM_APPOINTMENT_INFO_TYPE"
            >
          </app-appointment-info>
        }
      </div>
    }
  }
  @if (isActiveTab(HISTORY)) {
    <div>
      @if (
        hasNoAppointments(
        (historyAppointments$ | async)?.length,
        isInit$ | async
        )
        ) {
        <div
          class="empty-appointments content-wrapper"
          >
          <h3 class="no-appointment-message">
            {{ "WAITINGROOM.EMPTY-APPOINTMENTS-HISTORY" | translate }}
          </h3>
        </div>
      }
      @if ((historyAppointments$ | async)?.length > 0) {
        <div
          class="appointment-info-wrapper"
          >
          @for (appointment of historyAppointments$ | async; track appointment) {
            <app-appointment-info
              [appointment]="appointment"
              [appointmentInfoType]="HISTORY_APPOINTMENT_INFO_TYPE"
              >
            </app-appointment-info>
          }
        </div>
      }
    </div>
  }
  <app-jitsi-settings-pop-up [buttonType]="'none'"></app-jitsi-settings-pop-up>
  } @if (isCurrentRole(ROLE_PATIENT)) {

  <div
    class="background-wrapper-image"
    [style.backgroundImage]="
        'url(' + (backgroundImg$ | async)?.backgroundImage + ')'
    "
    >
    @if ((appointments$ | async)?.length > 0) {
      <div
        class="appointment-info-for-patients-wrapper"
        >
        @for (appointment of appointments$ | async; track appointment) {
          <app-appointment-info-for-patients
            [appointment]="appointment"
            >
          </app-appointment-info-for-patients>
        }
      </div>
    }
  </div>
}
